import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { FilterAdministrationContext } from '../../../filter-administration.context';
import { EditorFilterTreeNode } from '../../../filter-administration.model';
import { FilterDetailsComponent } from '../../../filter-details-component.model';

@Component({
  selector: 'app-filter-node-editor',
  templateUrl: './filter-node-editor.component.html',
  styleUrls: ['./filter-node-editor.component.scss']
})
export class FilterNodeEditorComponent implements OnInit, OnDestroy, FilterDetailsComponent {

  node: EditorFilterTreeNode;

  filterAdministrationContext: FilterAdministrationContext;
  filterAdministrationContextSubscription: Subscription;

  constructor() { }

  ngOnInit(): void {
  }

  ngOnDestroy() {
    if (this.filterAdministrationContextSubscription != null) {
      this.filterAdministrationContextSubscription.unsubscribe();
    }
  }

  setFilterAdministrationContext(filterAdministrationContext: FilterAdministrationContext) {
    this.filterAdministrationContext = filterAdministrationContext;
    this.node = this.filterAdministrationContext.getSelectedFilterTreeNode();
    this.filterAdministrationContextSubscription = this.filterAdministrationContext.contextChange$.subscribe(
      change => {
        try {
          if (change.key === 'selected-filter-node-changed') {
            this.node = change.value;
          }
        } catch (error) {
          console.log(error);
        }
      }
    );
  }
}
